<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <!--列表-->
    <el-table
      :data="sysOrgData"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      style="width: 100%"
      row-key="Id"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="Id" label="ID"></el-table-column>
      <el-table-column prop="Name" label="名称"></el-table-column>
      <el-table-column prop="Remark" label="备注"></el-table-column>
      <el-table-column
        prop="CreateTime"
        :formatter="formatCreateTime"
        label="创建时间"
      ></el-table-column>
    </el-table>

    <!--新增界面-->
    <el-dialog
      :title="isEdit ? '修改' : '新增'"
      :visible.sync="dmFormVisible"
      v-model="dmFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="dmForm"
        label-width="120px"
        :rules="dmFormRules"
        ref="dmForm"
      >
        <el-form-item label="组织名称" prop="Name">
          <el-input v-model="dmForm.Name" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="Remark">
          <el-input v-model="dmForm.Remark" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item prop="IsButton" label="是否为公司">
          <el-switch
            v-model="dmForm.IsCompany"
            active-value="1"
            inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item prop="IsButton" label="是否为搅拌站">
          <el-switch
            v-model="dmForm.IsStation"
            active-value="1"
            inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item prop="IsButton" label="是否为部门">
          <el-switch
            v-model="dmForm.IsDepartment"
            active-value="1"
            inactive-value="0"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="dmFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="Submit"
          :loading="submitLoading"
        >
          提交
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  getSysOrgListPage,
  getSysOrgDeatil,
  editSysOrg,
  removeSysOrg,
  addSysOrgPost,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      //表格用到的东西
      buttonList: [], //按钮组 初始化获取路由加载
      sysOrgData: [], //数据
      listLoading: false, //是否显示加载状态 false为不显示
      page: 1, //页码
      filters: {
        name: "", //输入内容的过滤条件
      },
      currentRow: {}, //当前选中的row
      isEdit: false, //false为新增
      //窗口用到的东西
      dmFormVisible: false, //添加窗口是否显示
      dmForm: {
        Name: "",
        Remark: "",
        IsCompany: 0,
        IsStation: 0,
        IsDepartment: 0,
        PID: null,
      }, //新增对象
      IsCompany: "0",
      submitLoading: false, //是否显示添加状态 false为不显示
      dmFormRules: {
        Name: [{ required: true, message: "请输入组织名称", trigger: "blur" }],
      }, //验证
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.page = 1;
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    formatCreateTime(row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
            new Date(row.CreateTime),
            "yyyy-MM-dd hh:mm:ss"
          );
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getSysOrg();
    },
    //获取用户列表
    getSysOrg() {
      let para = {
        page: this.page,
        key: this.filters.name,
      };
      this.listLoading = true;
      getSysOrgListPage(para).then((res) => {
        let data = res.data.response.data;
        //处理父子结构数据
        data.map((x) => {
          x["children"] = data.filter((y) => y.PID == x.Id);
        });
        data = data.filter(
          (x) => x.PID == "00000000-0000-0000-0000-000000000000"
        );
        this.sysOrgData = data;
        this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row.hasOwnProperty("Id")) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeSysOrg(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getSysOrg();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row.hasOwnProperty("Id")) {
        this.$message({
          message: "请选择要编辑的一行组织！",
          type: "error",
        });
        return;
      }
      this.isEdit = true;
      console.log(this.currentRow);
      this.dmForm = Object.assign({}, this.dmForm, this.currentRow);
      this.dmForm.IsCompany = this.currentRow.IsCompany + "";
      this.dmForm.IsStation = this.currentRow.IsStation + "";
      this.dmForm.IsDepartment = this.currentRow.IsDepartment + "";
      this.dmFormVisible = true;
    },
    //显示新增界面
    handleAdd() {
      let row = this.currentRow;
      if (!row.hasOwnProperty("Id")) {
        this.$message({
          message: "请选择要新增下属组织的组织！",
          type: "error",
        });
        return;
      }

      this.isEdit = false;
      this.dmForm = {};
      this.dmForm.PID = this.currentRow.Id;
      this.dmFormVisible = true;
    },
    //显示新增根节点界面
    handleRootAdd() {
      this.dmForm = {};
      this.isEdit = false;
      this.dmFormVisible = true;
    },
    Submit() {
      this.isEdit ? this.editSubmit() : this.addSubmit();
    },
    //编辑
    editSubmit() {
      this.$refs.dmForm.validate((valid) => {
        console.log(this.dmForm);
        if (valid) {
          this.submitLoading = true;
          editSysOrg(this.dmForm)
            .then((res) => {
              if (res.status == 200) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.dmFormVisible = false;
                this.getSysOrg();
              }
            })
            .catch((res) => {
              this.$message({
                message: res,
                type: "error",
              });
            })
            .finally(() => {
              this.submitLoading = false;
            });
        }
      });
    },
    //新增
    addSubmit() {
      this.$refs.dmForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          addSysOrgPost(this.dmForm)
            .then((res) => {
              if (res.status == 200) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.dmFormVisible = false;
                this.getSysOrg();
              }
            })
            .catch((res) => {
              this.$message({
                message: res,
                type: "error",
              });
            })
            .finally(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
  mounted() {
    this.getSysOrg();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped></style>
